import { render } from "./InstantIMDReportCard.vue?vue&type=template&id=60c0707e&scoped=true"
import script from "./InstantIMDReportCard.vue?vue&type=script&lang=js"
export * from "./InstantIMDReportCard.vue?vue&type=script&lang=js"

import "./InstantIMDReportCard.vue?vue&type=style&index=0&id=60c0707e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c0707e"]])

export default __exports__